import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MODAL_TYPES } from '../modal-type/constants';
import { setModalType } from '../modal-type/slice';
import { ParticipantListState } from './types';

const initialState: ParticipantListState = {
    pageIdx: 0,
};

const participantListSlice = createSlice({
    name: 'dtmf-participant-list',
    initialState,
    reducers: {
        setPageIdx(state: ParticipantListState, action: PayloadAction<number>) {
            state.pageIdx = action.payload;
        },
        hideParticipantList() {
            return { ...initialState };
        },
    },
});

export const participantListReducer = participantListSlice.reducer;
export const { setPageIdx, hideParticipantList } = participantListSlice.actions;
export const showParticipantList = () => setModalType(MODAL_TYPES.participantList);
